export default class Spotlight {
  constructor(el = '.notice-item') {
    this.el = el;
    try {
      this.initialize();
    } catch (e) {
      console.warn('Spotlight');
      console.warn(e);
    }
  }

  initialize() {
    //order by last update as default
    this.order('lastupdated');
  }

  order(type) {
    //build array of items
    const items = [...document.querySelectorAll(this.el)];
    switch (type) {
      case 'lastupdated':
        this.orderbylastupdated(items);
        break;
    }
  }

  orderbylastupdated(items) {
    const parent = items[0].parentNode;
    const sorted = items.sort(function (a, b) {
      return +b.dataset.lastupdated - +a.dataset.lastupdated;
    });
    //parent.textContent = "";
    sorted.forEach((el) => {
      parent.insertAdjacentElement('beforeend', el);
    });
  }
}
